import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';  // ✅ Import HelmetProvider
import "./App.css";
import Header from "./components/header.js";
import Hero from "./components/hero.js";
import ClientSection from "./components/ClientLogos.js";
import CarouselSection from "./components/Carousel.js";
import MarketingStrategy from "./components/MarketingStrategyNOOO.js";
import Hero5 from "./components/hero5.js";
import Hero6 from "./components/hero6.js";
import FAQSection from "./components/faq.js";
import Hero8 from "./components/hero8.js";
import Footer from "./components/footer.js";
import Contact from "./components/contact";
import SEOSection from "./components/services.js/seo.js";
import SMMSection from "./components/services.js/social-media-marketing.js";
import EmailMarketingSection from "./components/services.js/email-marketing.js";
import GoogleAdsSection from "./components/services.js/google-ads.js";
import InfluencerSection from "./components/services.js/influencer-marketing.js";
import OrmSection from "./components/services.js/orm.js";
import PrAgencySection from "./components/services.js/pr-agency.js";
import WebsiteSection from "./components/services.js/website-designing.js";
import AppDevelopmentSection from "./components/services.js/app-development.js";
import Whatsapp from "./components/services.js/whatsapp-marketing.js";
import QuotationForm from "./components/requestQuotes.js";
import AboutUs from "./components/aboutus.js";
import ServicesPage from "./components/services.js/services.js";
import BlogList from "./components/BlogList.js";
import BlogPost from "./components/BlogPost.js";
import MarketingStatistics from "./components/marketing-statistics.js";
import MarketingDetails from "./components/MarketingDetails.js";
import Testimonials from './components/testimonials';
import PageTitle from './components/PageTitle';
import JotformAgent from './components/JotformAgent'; // Adjust the path if needed

// ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <HelmetProvider>  {/* ✅ Wrap the whole app inside HelmetProvider */}
      <Router>
        <ScrollToTop />
        <PageTitle />
        <Header />
        <Routes>
          {/* Home Page */}
          {/* <Route path="/" element={<Hero />} /> */}
          <Route path="/" element={
            <>
              <Hero />
              <ClientSection />
              {/* <CarouselSection /> */}
              <MarketingStrategy />
              <Hero5 />
              <Hero6 />
              {/* <Testimonials /> */}
              <FAQSection />
              <Hero8 />
            </>
          } />
          <Route path="/contact" element={<Contact />} />
          <Route path="/company" element={<Hero8 />} />
          <Route path="/services" element={<ServicesPage />} />
          
          {/* Blog Routes */}
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          
          <Route path="/marketing-statistics" element={<MarketingStatistics />} />
          <Route path="/marketing-details" element={<MarketingDetails />} />

          {/* Services Pages */}
          <Route path="/services/seo" element={<SEOSection />} />
          <Route path="/services/social-media-marketing" element={<SMMSection />} />
          <Route path="/services/email-marketing" element={<EmailMarketingSection />} />
          <Route path="/services/google-ads" element={<GoogleAdsSection />} />
          <Route path="/services/influencer-marketing" element={<InfluencerSection />} />
          <Route path="/services/website-development" element={<EmailMarketingSection />} />
          <Route path="/services/ecommerce-website" element={<GoogleAdsSection />} />
          <Route path="/services/pr-agency" element={<PrAgencySection />} />
          <Route path="/services/orm" element={<OrmSection />} />
          <Route path="/services/website-designing" element={<WebsiteSection />} />
          <Route path="/services/app-development" element={<AppDevelopmentSection />} />
          <Route path="/services/whatsapp-marketing" element={<Whatsapp />} />

          <Route path="/requestquotes" element={<QuotationForm />} />
          <Route path="/aboutus" element={<AboutUs />} />
        </Routes>
        <Footer />
                <JotformAgent />
      </Router>
    </HelmetProvider>
  );
}

export default App;
